export default {
    name: 'auth-apple',
    created() {
        // if (document.getElementById("scriptAppleAuth")) {
        //     return;
        // }
        // const scriptTag = document.createElement("script");
        // scriptTag.src = "https://appleid.cdn-apple.com/appleauth/static/jsapi/appleid/1/en_US/appleid.auth.js";
        // scriptTag.id = "scriptAppleAuth";
        // document.head.appendChild(scriptTag);
    },
    mounted() {
        AppleID.auth.init({
            clientId: '[CLIENT_ID]',
            scope: '[SCOPES]',
            redirectURI: '[REDIRECT_URI]',
            state: '[STATE]',
            usePopup: true //or false defaults to false
        });
    },
    methods: {
        singIn() {
            AppleID.auth.signIn();
        }
    },
    destroyed() {
        // if (document.getElementById("scriptAppleAuth")) {
        //     document.getElementById("scriptAppleAuth").remove()
        // }
    }
}
